// This file can be replaced during build by using the `fileReplacements` array.
// `ng build --prod` replaces `environment.ts` with `environment.prod.ts`.
// The list of file replacements can be found in `angular.json`.

export const environment = {
  production: true,
  api: "https://api-abr.abrapa.com.br",
  redirecionamento_externo: "https://siga.abrapa.com.br/",
  api_convites: "https://api-convites.abrapa.com.br/api/v1",
  convites: "https://convites.abrapa.com.br/",
  sentryDSN: "",
  dataLimiteRespostaConvite: "2023-05-31",
};

/*
 * For easier debugging in development mode, you can import the following file
 * to ignore zone related error stack frames such as `zone.run`, `zoneDelegate.invokeTask`.
 *
 * This import should be commented out in production mode because it will have a negative impact
 * on performance if an error is thrown.
 */
// import 'zone.js/dist/zone-error';  // Included with Angular CLI.
